import React from 'react'
import { DiscordSocial, TwitterSocial } from 'src/assets/images'

import './SocialButton.scss'

interface IProps {
  icon: 'discord' | 'twitter'
  url: string
}

export function SocialButton(props: IProps) {
  const iconImage = props.icon === 'discord' ? DiscordSocial : TwitterSocial

  return (
    <div>
      <a href={props.url} target="_blank" rel="noopener noreferrer" className="social-button">
        <img className="social-button__img" src={iconImage} alt={`${props.icon} icon`} />
      </a>
    </div>
  )
}
